import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonExternal } from '../ui/Button';
import { DoodleStar, DoodleUnderline } from '../brand/Doodles';
import { externalLinks } from '../../data/site';
export function FinalCta() {
  return <Section className="relative overflow-hidden bg-brand-blue py-16 sm:py-24" labelledBy="cta-heading" data-id="element-128" data-mp="2peezeyb4w039">
      <DoodleStar className="pointer-events-none absolute left-6 top-8 h-10 w-10 sm:h-14 sm:w-14" color="var(--bcm-yellow)" data-id="element-129" data-mp="2ke0ptbtvwi34" />
      <Container className="max-w-3xl text-center" data-id="element-130" data-mp="1rs7n128l93gc">
        <h2 id="cta-heading" className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-navy sm:text-6xl" data-id="element-131" data-mp="1rpbr1jgawouj">
          There’s a place for you here.
        </h2>
        <DoodleUnderline className="mx-auto mt-3 h-4 w-56" color="var(--bcm-pink)" data-id="element-132" data-mp="1e01eo2bog0rg" />
        <p className="mx-auto mt-6 max-w-xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-133" data-mp="1dxosfcyvz48l">
          Tell us a little about yourself, ask a question, or let a BCM leader help you take the next
          step.
        </p>

        <div className="mt-8 flex justify-center" data-id="element-134" data-mp="3rd31eq3qso5h">
          <ButtonExternal href={externalLinks.getConnectedForm} data-id="element-135" data-mp="3rbrz6upy3ogh">Let’s Get Connected</ButtonExternal>
        </div>

        <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4" data-id="element-136" data-mp="1077p2f8o4y">
          <ButtonExternal href={externalLinks.discord} variant="secondary" className="w-full sm:w-auto" data-id="element-137" data-mp="4zuqst87qgq4">
            Join the Discord
          </ButtonExternal>
          <ButtonExternal href={externalLinks.instagram} variant="secondary" className="w-full sm:w-auto" data-id="element-138" data-mp="38fialdhf3fi8">
            Follow on Instagram
          </ButtonExternal>
          <ButtonExternal href={externalLinks.email} variant="secondary" className="w-full sm:w-auto" data-id="element-139" data-mp="3icmxjfj37f03">
            Email UCF BCM
          </ButtonExternal>
        </div>
      </Container>
    </Section>;
}